// userSelectors.js

export const selectLoading = (state) => state.register.loading;
export const selectSuccessMsg = (state) => state.register.successMsg;
export const selectSuccessCreateProfileMsg = (state) => state.register.successCreateProfileMsg;